export default __webpack_public_path__ + "static/media/let.2aa38389.jpeg";